import React from 'react';
import classnames from 'classnames';

import SampleTypeContent from '../../../core/components/SampleTypeContent';
import { SampleProcessingStatus, SampleType } from '@models';

type SampleTypeCellProps = {
  sampleType: SampleType;
  warning: {
    status: SampleProcessingStatus;
    message: string;
  };
};

const SampleTypeCell: React.VFC<SampleTypeCellProps> = ({
  sampleType,
  warning: { status, message },
}) => (
  <td
    className={classnames({
      'sample-type-warning': status === 'ProcessingWithWarning',
    })}
    style={{ wordBreak: 'normal' }}
  >
    <SampleTypeContent
      sampleType={sampleType}
      warning={{
        status,
        message,
      }}
    />
  </td>
);

export default SampleTypeCell;
